export default __webpack_public_path__ + "static/media/20000_new_front.29c38c43.jpg";